var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHours = function SvgHours(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M23.076 13.886a.565.565 0 1 1-.002 1.131.566.566 0 1 1 .002-1.13M22.56 17.613a.565.565 0 1 1-.435 1.043.567.567 0 0 1-.305-.74.567.567 0 0 1 .74-.303M20.658 20.857a.565.565 0 1 1-.8.798.565.565 0 0 1 .8-.798",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#867CFC",
    fillRule: "evenodd",
    d: "M13.453 15.02a.565.565 0 0 1-.566-.567V6.528a.567.567 0 0 1 1.132 0v7.925a.565.565 0 0 1-.566.566",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#867CFC",
    fillRule: "evenodd",
    d: "M13.453 13.886a.567.567 0 0 0 0 1.133.568.568 0 0 0 0-1.133m0 2.264c-.936 0-1.698-.76-1.698-1.697a1.699 1.699 0 0 1 3.396 0c0 .937-.762 1.697-1.698 1.697",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#867CFC",
    fillRule: "evenodd",
    d: "M13.453 26.905C6.586 26.905 1 21.32 1 14.453 1 7.585 6.586 2 13.453 2c5.907 0 11.04 4.196 12.207 9.979a.566.566 0 1 1-1.11.222c-1.06-5.255-5.726-9.068-11.097-9.068-6.243 0-11.32 5.078-11.32 11.32 0 6.241 5.077 11.321 11.32 11.321q.224 0 .447-.01c.293-.05.577.224.592.538a.567.567 0 0 1-.537.593q-.25.011-.502.01",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#CBC8F2",
    fillRule: "evenodd",
    d: "M24.208 15.602a7.36 7.36 0 0 0-7.359 7.358c0 1.742.61 3.342 1.623 4.601a7.3 7.3 0 0 0 4.604 1.625 7.36 7.36 0 0 0 7.358-7.359c0-1.742-.61-3.342-1.623-4.601a7.3 7.3 0 0 0-4.603-1.624",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#867CFC",
    fillRule: "evenodd",
    d: "M23.076 29.752c-4.37 0-7.925-3.554-7.925-7.925 0-4.369 3.555-7.925 7.925-7.925 1.53 0 3.014.439 4.292 1.264a.567.567 0 0 1-.614.951 6.74 6.74 0 0 0-3.678-1.082 6.8 6.8 0 0 0-6.793 6.792c0 3.746 3.047 6.794 6.793 6.794s6.792-3.048 6.792-6.794c0-.725-.114-1.44-.338-2.123a.57.57 0 0 1 .36-.717.567.567 0 0 1 .714.362c.264.8.396 1.633.396 2.478 0 4.371-3.555 7.925-7.924 7.925",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#867CFC",
    fillRule: "evenodd",
    d: "M22.51 24.884h-.014a.57.57 0 0 1-.422-.204l-2.83-3.397a.567.567 0 0 1 .871-.725l2.415 2.9 7.035-7.772a.565.565 0 1 1 .834.764l-7.471 8.25a.57.57 0 0 1-.419.184",
    clipRule: "evenodd"
  })));
};
export default SvgHours;